import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("As senhas não conferem");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token: params.get("token"), password: pw });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6 grain">
      <form onSubmit={submit} className="card-surface w-full max-w-md p-8 space-y-4" data-testid="reset-password-form">
        <h1 className="text-2xl font-bold">Redefinir senha</h1>
        <Field label="Nova senha"><Input type="password" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-password-input" /></Field>
        <Field label="Confirme a nova senha"><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="reset-password-confirm-input" /></Field>
        <Button type="submit" className="w-full h-11" disabled={busy} data-testid="reset-password-submit">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Salvar nova senha</Button>
        <Link to="/login" className="block text-center text-sm text-muted-foreground">Voltar ao login</Link>
      </form>
    </div>
  );
}
